import { Component, OnInit, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-footer',
    templateUrl: './footer.shared.component.html',
    styleUrls: ['./footer.shared.component.scss']
})
export class FooterComponent implements OnInit {
    constructor(
        @Inject(Tokens.ENV_BUILD_TOKEN) private _envBuildToken: IEnvironment,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void { }

    public get version(): string {
        return this._envBuildToken?.version || '';
    }

    public get links$(): Observable<IConfigLink[]> {
        return this.controllers.appSettings.appSettingsLinks$();
    }

    public handleLinkClick($event: Event, link: IConfigLink): void {
        $event.preventDefault();
        if (!link.url) {
            return console.warn('Link url not provided. Check API settings or config.js file in "links" property of type Array', link);
        }
        window.open(link.url, '_blank');
    }
}
